import type { LosResult } from '../lib/los';

const NS = 'http://www.w3.org/2000/svg';
const W = 320;
const H = 140;
const PAD = { l: 34, r: 8, t: 10, b: 20 };

function el<K extends keyof SVGElementTagNameMap>(tag: K, attrs: Record<string, string | number>, parent: Element) {
  const e = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, String(v));
  parent.appendChild(e);
  return e;
}

/** Terrain profile home→site with the radio line and the 0.6·F1 band. Replaces any previous chart in `host`. */
export function renderProfile(host: HTMLElement, ground: number[], los: LosResult, distanceM: number): void {
  host.querySelector('svg.profile')?.remove();
  const n = ground.length;
  const lower = los.lineM.map((l, i) => l - 0.6 * los.fresnelM[i]);
  const all = [...ground, ...los.lineM, ...lower];
  const lo = Math.floor(Math.min(...ground) - 5);
  const hi = Math.ceil(Math.max(...all) + 5);
  const x = (i: number) => PAD.l + (i / (n - 1)) * (W - PAD.l - PAD.r);
  const y = (h: number) => PAD.t + (1 - (h - lo) / (hi - lo)) * (H - PAD.t - PAD.b);

  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
  svg.setAttribute('class', 'profile');
  svg.setAttribute('role', 'img');
  svg.setAttribute('aria-label', `Profilo del terreno, visuale ${los.status}`);

  // band between the line and 0.6·F1 below it
  const band = los.lineM.map((l, i) => `${x(i)},${y(l)}`).concat(lower.map((l, i) => `${x(n - 1 - i)},${y(lower[n - 1 - i])}`).map(String));
  el('polygon', { class: 'fresnel', points: band.join(' ') }, svg);

  const terrain = `M${x(0)},${y(lo)} ` + ground.map((g, i) => `L${x(i)},${y(g)}`).join(' ') + ` L${x(n - 1)},${y(lo)} Z`;
  el('path', { class: 'terrain', d: terrain }, svg);

  el('line', { class: 'los-line', x1: x(0), y1: y(los.lineM[0]), x2: x(n - 1), y2: y(los.lineM[n - 1]) }, svg);

  if (los.status !== 'libera' && los.worstIndex > 0) {
    el('circle', { class: los.status === 'ostruita' ? 'obstruction' : 'marginal', cx: x(los.worstIndex), cy: y(ground[los.worstIndex]), r: 4 }, svg);
  }

  // axes labels
  const t1 = el('text', { class: 'axis', x: 2, y: y(hi) + 8 }, svg);
  t1.textContent = `${hi} m`;
  const t2 = el('text', { class: 'axis', x: 2, y: y(lo) }, svg);
  t2.textContent = `${lo} m`;
  const t3 = el('text', { class: 'axis', x: PAD.l, y: H - 4 }, svg);
  t3.textContent = 'Casa';
  const t4 = el('text', { class: 'axis', x: W - PAD.r, y: H - 4, 'text-anchor': 'end' }, svg);
  t4.textContent = `Antenna · ${(distanceM / 1000).toFixed(1)} km`;

  host.appendChild(svg);
}
